module.exports = __webpack_public_path__ + "media/fonts/Inter-Black-83d81b16.ttf";